import { AnyAction } from 'redux';

import { tollActions } from '../reducer';

export const resetActiveTollSection = (): AnyAction => tollActions.setActiveTollSection(null);
